import { gql } from "@apollo/client";

export const DELETE_VISITA = gql`
mutation deleteVisita($idVisita: Int!) {
    deleteVisita(idVisita: $idVisita)
}`;